module.exports = __webpack_public_path__ + "static/media/  (69).247f4844.jpg";